import React, { Fragment, Suspense, lazy } from "react";
import {
  BrowserRouter,
  HashRouter,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import arrMenu from "./../../constants/menuRoutes";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import TourEnd from "../../screens/tourend";

window.si_yahoo_quiz = window.si_yahoo_quiz || {};

const Home = lazy(() =>
  import(/* webpackChunkName: 'home' */ "./../../screens/home")
);

const LeaderBoard = lazy(() =>
  import(/* webpackChunkName: 'leaderboard' */ "./../../screens/leaderboard")
);

const Answers = lazy(() =>
  import(/* webpackChunkName: 'answers' */ "./../../screens/answers")
);

const Rules = lazy(() =>
  import(/* webpackChunkName: 'rules' */ "./../../screens/rules")
);

const Terms = lazy(() =>
  import(/* webpackChunkName: 'terms' */ "./../../screens/terms")
);

const NoMatch = lazy(() =>
  import(/* webpackChunkName: 'noMatch' */ "./../noMatch")
);

// const TourEnd = lazy(() =>
//   import(/* webpackChunkName: 'home' */ "./../../screens/tourend")
// );

let location = window.location.href;
let ObjRoute = {
  "/home": Home,
  "/leaderboard": LeaderBoard,
  "/answers": Answers,
  "/rules": Rules,
  "/terms": Terms,
};
const doDefaultNavigation = (DefaultComponent, path, route, props) => {
  let isAuthorize = route.validator ? route.validator(route) : true;
  switch (path) {
    case "/home":
      document.title =
        config.trans && config.trans.titleHome
          ? config.trans.titleHome
          : "FIH QUIZ HOME";
      break;

    case "/leaderboard":
      document.title =
        config.trans && config.trans.titleLeaderboard
          ? config.trans.titleLeaderboard
          : "FIH QUIZ LEADERBOARD";
      break;

    case "/answers":
      document.title =
        config.trans && config.trans.titleAnswers
          ? config.trans.titleAnswers
          : "FIH QUIZ ANSWERS";
      break;

    case "/terms":
      document.title =
        config.trans && config.trans.titleTerms
          ? config.trans.titleTerms
          : "FIH QUIZ TERMS";
      break;

    case "/rules":
      document.title =
        config.trans && config.trans.titleRules
          ? config.trans.titleRules
          : "FIH QUIZ RULES";
      break;

    default:
      document.title = "";
      break;
  }

  if (
    path != config.enumStaticUrls.home &&
    (path == config.BASE_DOMAIN || !isAuthorize)
  ) {
    return <Redirect to={config.enumStaticUrls.home} {...props} />;
  }

  if (DefaultComponent) {
    return <DefaultComponent {...props} />;
  } else {
    return <Redirect to={config.enumStaticUrls.home} {...props} />;
  }
};

// const UserContext = React.createContext();

class Routes extends React.Component {
  constructor() {
    super();
    this.state = {
      myRoutes: [],
      isDateUpdate: null,
      popupNode: null,
      jMode: config.enumGameMode.live,
      menus: arrMenu,
      goAhead: false,
      userCurrentTime: "",
    };

    let eventValidators = app.eventValidators;
    let eventValidatorsGameLocked = app.eventValidatorsGameLocked;
    let eventValidatorsGameplayLocked = app.eventValidatorsGameplayLocked;
    // let eventValidatorsLoggedIn = app.eventValidatorsLoggedIn;

    this.routes = [];
    this.state.menus.forEach((menu) => {
      let route = {};
      route.path = menu.link;
      route.validator = menu.validator;
      route.component = ObjRoute[menu.link] ? ObjRoute[menu.link] : null;
      route.transKey = menu.transKey;
      this.routes.push(route);
    });
  }

  componentDidMount() {
    app.getTranslations((resp) => {
      if (resp) {
        this.setState({
          goAhead: true,
          userCurrentTime: resp?.Meta?.Timestamp?.CESTTime,
        });
      }
    });
  }

  render() {
    const self = this;
    const { nodeLoader } = self.props;
    const { userCurrentTime } = self.state;

    const myRoutes = this.routes.map((el, index) => {
      let component = el.component;
      let path = el.path;

      if (path == config.BASE_DOMAIN) {
        return (
          <>
            <Route
              exact
              key={index}
              path={path}
              render={(props) =>
                doDefaultNavigation(component, path, el, {
                  ...this.props,
                  ...props,
                })
              }
            />
          </>
        );
      }

      return (
        <Route
          exact
          key={index}
          path={path}
          render={(props) =>
            doDefaultNavigation(component, path, el, {
              ...this.props,
              userCurrentTime,
              ...props,
            })
          }
        />
      );
    });

    return self.state.goAhead ? (
      <HashRouter>
        <Suspense fallback={nodeLoader}>
          <Switch>
            {myRoutes}
            <Route component={NoMatch} />
          </Switch>
        </Suspense>
      </HashRouter>
    ) : (
      nodeLoader
    );
  }
}

export default Routes;
